import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { LoginService, LoginPayload, ApiResponse } from '../services/login.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { RedefinicaoSenhaComponent } from './solicitacao-redefinicao-senha/solicitacao-redefinicao-senha.component';
import { parseBackendResponse } from '../services/api-response.util';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule,
    ReactiveFormsModule,
    RouterModule,
    RedefinicaoSenhaComponent],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginUsuario!: FormGroup;
  showForgotPasswordModal: boolean = false;
  mensagemErro: string | null = null;

  constructor(
    private fb: FormBuilder,
    private loginService: LoginService,
    private routes: Router,
    private toastr: ToastrService,
    private cookieService: CookieService
  ) { }

  ngOnInit() {
    this.loginUsuario = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      senha: ['', [Validators.required]]
    });
  }

  mostrarSenha: boolean = false;

  toggleSenha() {
    this.mostrarSenha = !this.mostrarSenha;
  }

  abrirModalEsqueciSenha() {
    this.showForgotPasswordModal = true;
  }

  fecharModalEsqueciSenha() {
    this.showForgotPasswordModal = false;
  }

  enviarFormulario() {

    if (this.loginUsuario.invalid) {

      this.loginUsuario.markAllAsTouched();

      this.toastr.warning('Por favor, verifique os campos destacados.', 'Formulário Inválido');

      return;
    }


    const payload: LoginPayload = this.loginUsuario.value;

    this.loginService.Login(payload).subscribe({
      next: (response) => {
        const tokenValue = response.token;
        const expires = new Date();
        expires.setMinutes(expires.getMinutes() + 40);

        this.cookieService.set('token', tokenValue, {
          expires: expires,
          sameSite: 'Strict',
          path: '/'
        })

        this.toastr.success('Login realizado com sucesso!', 'Bem-vindo!');
        this.routes.navigate(['/home']);
      },
      error: (err) => {
        const parsed = parseBackendResponse(err?.error, err?.status);
        let errorMsg = parsed.mensagem || 'Ocorreu um erro desconhecido.';

        this.toastr.error(errorMsg, 'Falha no Login');
      }
    });
  }
}
